import SmartBanner from 'smartbanner.js/src/smartbanner.js';

const ORIGINAL_MARGIN_ATTR = 'data-smartbanner-original-margin-top';
const HIDE_BANNER_SELECTORS = ['.main-chat-container', '.onboarding-navbar'];
const BANNER_SELECTOR = '.js_smartbanner';

function cleanupBanner() {
  const banner = document.querySelector(BANNER_SELECTOR);
  if (banner) banner.remove();

  const html = document.documentElement;
  html.style.marginTop = '';
  html.removeAttribute(ORIGINAL_MARGIN_ATTR);
}

function publishBanner() {
  if (document.querySelector(BANNER_SELECTOR)) return;

  document.documentElement.removeAttribute(ORIGINAL_MARGIN_ATTR);

  try {
    const sb = new SmartBanner();
    sb.publish();
  } catch (_e) {
    // SmartBanner throws when meta tags are missing or platform doesn't match
  }
}

document.addEventListener('turbo:load', function () {
  if (HIDE_BANNER_SELECTORS.some((selector) => document.querySelector(selector))) {
    cleanupBanner();
  } else {
    publishBanner();
  }
});
